import { Component, Input } from '@angular/core';

import { PaymentTruemoneyComponent } from '../../payment-truemoney.component';

/**
 * "the_portrait" view of /payment-truemoney.
 *
 * Two stages, driven by host.isPhoneNumberNotProvided exactly as the default theme is:
 *   1. mobile-number entry — no mockup exists, so it is derived from /promo-type's shape
 *      (bordered field + the themed numeric keypad).
 *   2. the standard QR panel, plus the TrueMoney wordmark and the masked number.
 */
@Component({
  selector: 'app-payment-truemoney-portrait',
  templateUrl: './payment-truemoney-portrait.component.html',
  styleUrls: ['./payment-truemoney-portrait.component.scss']
})
export class PaymentTruemoneyPortraitComponent {

  @Input() host!: PaymentTruemoneyComponent;

}
